import { Instagram, Heart, Music, Sparkles } from "lucide-react";
import { TESTIDS, INSTAGRAM_URL, INSTAGRAM_HANDLE } from "@/lib/site";
import { useReveal } from "@/lib/useReveal";

export default function InstagramSection() {
  const r = useReveal();

  return (
    <section
      id="instagram"
      data-testid={TESTIDS.instagram.section}
      className="relative py-24 md:py-32 bg-warm-beige/40 overflow-hidden"
    >
      {/* Soft organic shapes */}
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-20 left-1/4 w-[420px] h-[420px] rounded-full bg-dusty-rose/25 blur-3xl" />
        <div className="absolute bottom-10 right-1/4 w-[380px] h-[380px] rounded-full bg-sage/25 blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <div className={r.className}>
          <p className="text-[0.78rem] tracking-[0.22em] uppercase text-accent-magenta mb-4">
            Instagram
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.6rem] text-editorial-dark leading-[1.05]">
            Acompáñame en
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="italic text-terracotta hover:text-accent-magenta transition-colors underline decoration-terracotta/40 decoration-2 underline-offset-[6px] hover:decoration-accent-magenta/60"
            >
              {" "}Instagram
            </a>
            .
          </h2>
          <p className="mt-6 text-editorial-gray leading-relaxed max-w-2xl mx-auto text-[1.02rem]">
            Un espacio para la sensibilidad, la música y el acompañamiento emocional.
            Reflexiones, contenido de bienestar y pequeñas pausas para volver a ti.
          </p>

          {/* Three soft pillars */}
          <div className="mt-12 grid md:grid-cols-3 gap-5 text-left">
            <Pillar
              icon={<Heart size={18} />}
              title="Reflexiones"
              text="Pensamientos breves para acompañar el día a día emocional."
            />
            <Pillar
              icon={<Music size={18} />}
              title="Música terapéutica"
              text="La música como puente hacia lo que las palabras no nombran."
            />
            <Pillar
              icon={<Sparkles size={18} />}
              title="Sensibilidad"
              text="Un lugar para detenerse, respirar y volver a escucharse."
            />
          </div>

          <a
            data-testid={TESTIDS.instagram.cta}
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-12 inline-flex items-center gap-3 rounded-full bg-editorial-dark text-warm-white px-7 py-4 text-[0.95rem] hover:-translate-y-0.5 transition-all shadow-md shadow-editorial-dark/15"
          >
            <Instagram size={18} />
            Seguirme en {INSTAGRAM_HANDLE}
          </a>
        </div>
      </div>
    </section>
  );
}

function Pillar({ icon, title, text }) {
  return (
    <div className="rounded-2xl bg-warm-white border border-dusty-rose/25 p-6 hover:-translate-y-0.5 transition-transform">
      <span className="inline-flex w-10 h-10 rounded-full bg-dusty-rose/30 text-accent-magenta items-center justify-center mb-4">
        {icon}
      </span>
      <p className="font-serif text-[1.35rem] text-editorial-dark leading-tight">
        {title}
      </p>
      <p className="text-sm text-editorial-gray mt-2 leading-relaxed">{text}</p>
    </div>
  );
}
